module.exports = __webpack_public_path__ + "img/rupiah-sign.09061d5a.svg";